import { PlatformReferralRoute } from '/@/modules/platformreferral/constants/PlatformReferralRoutes';
import ReferralLayout from '/@/modules/platformreferral/pages/ReferralLayout.vue';
import { PlatformReferralRouteConfig } from '/@/modules/platformreferral/routes/PlatformReferralRouteConfig';

export const router = [
  {
    path: `/${PlatformReferralRoute.VIEWS.path}`,
    name: PlatformReferralRoute.VIEWS.name,
    component: ReferralLayout,
    children: [
      PlatformReferralRouteConfig.factory({
        path: `${PlatformReferralRoute.FREE_WILL_REFERRALS.path}/:referralId`,
        name: PlatformReferralRoute.FREE_WILL_REFERRALS.name,
        component: () => import('/@/modules/platformreferral/pages/FreeWillReferralPage.vue'),
        props: (route) => ({
          referralId: route.params?.referralId
        }),
        meta: { authOnly: false }
      }).build()
    ]
  }
];
